import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import LineChart from '../cards/LineChart'
import BarChart from '../cards/BarChart'
import TableChart from '../cards/TableChart.vue'
import './operation.less'
import { exportRps } from '@/api/api';
import { getLocalStorage } from "@/utils/storage";

@Component({
  components: {
    LineChart,
    BarChart,
    TableChart
  }
})
export default class OperationBody extends Vue {
  @Prop({ default: () => ([]) }) data: Array<any>
  @Prop({ default: () => ([]) }) columns: Array<any>
  @Prop({ default: () => ([]) }) shiftList: Array<any>
  @Prop({ default: () => ({}) }) filter: any
  @Prop({ default: false }) loading: Boolean
  @Prop({ default: 1 }) searchType: Number // 对比关系：1：设备对比，2：时间对比
  showType: String = 'pie'
  visible: Boolean = false
  checkItem = []

  selectChart(value, item) {
    if (value.target.checked) {
      this.dataChecked(true, item)
      this.checkItem.push(item)
    } else {
      this.dataChecked(false, item)
      this.checkItem.splice(this.checkItem.indexOf(item), 1)
    }
  }

  dataChecked(bool, item) {
    this.data.forEach(res => {
      if (res == item) {
        res.checked = bool
      }
    })
  }

  chartBody(item, index) {
    if (this.showType === 'line') {
      return (
        <div class="charts">
          <line-chart columns={this.columns} dataValue={[item]} index={index}></line-chart>
        </div>
      )
    } else if (this.showType === 'pie') {
      return (
        <div class="charts">
          <bar-chart columns={this.columns} dataValue={[item]} index={index} searchType={this.searchType}></bar-chart>
        </div>
      )
    } else {
      return (<table-chart columns={this.columns} dataValue={[item]} index={index}></table-chart>)
    }
  }

  chartRecheck() {
    if (this.showType === 'line') {
      return (
        <line-chart columns={this.columns} dataValue={this.checkItem}></line-chart>
      )
    } else if (this.showType === 'pie') {
      return (
        <bar-chart columns={this.columns} dataValue={this.checkItem} searchType={this.searchType}></bar-chart>
      )
    } else {
      return (<table-chart columns={this.columns} dataValue={this.checkItem}></table-chart>)
    }
  }

  handleShowTypeChange(value) {
    this.showType = value
    this.checkItem = []
    this.data.forEach(res => {
      res.checked = false
    })
    this.$emit('toggleSearchType',1)
  }

  handleRecheck() {
    this.visible = true
  }

  handleOk() {
    this.visible = false
  }

  renderLoading(){
    return (
      <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 34px" spin />
        </a-spin>
      </div>
    )
  }

  export(){
    let settings = getLocalStorage('USER_INFO')
    this.filter.tenantId = settings.tenant_id
    exportRps(this.filter).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_operation_statistics')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  getShiftName(name) { // 2021-06-25_1
    if(!name) {
      return ''
    }
    // console.log('shiftList========>',this.shiftList)
    let code = name.split('_')[1]
    let extra = name.split('_')[0]
    let findResults = this.shiftList.find(item=>item.key===code)
    let shiftName = findResults ? findResults.name : ''
    return shiftName ? (extra + '_' + shiftName) : extra
  }
  render() {
    return (
      <blank-view>
        <div slot="action">
          <div style="display: flex; justify-content: space-between;">
            <div>
              <a-button type="default" disabled={!(this.checkItem.length > 1)} onClick={() => this.handleRecheck()} style="margin-right: 8px;">{this.$t('page_operation_statistics_contrast')}</a-button>
              <a-button type="primary" onClick={() => this.export()}>{this.$t('page_product_export')}</a-button>
            </div>
            <a-radio-group value={this.showType} onChange={data => this.handleShowTypeChange(data.target.value)}>
              <a-radio-button value="line">
                { this.$t('page_operation_statistics_linechart') }
              </a-radio-button>
              <a-radio-button value="pie">
                { this.$t('page_operation_statistics_barchart') }
              </a-radio-button>
              <a-radio-button value="table">
                { this.$t('page_operation_statistics_tablechart') }
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div style="height: 100%;">
          {this.showType==='pie'&&<a-radio-group value={this.searchType} onChange={data => this.$emit('toggleSearchType',data.target.value)}>
            <a-radio-button value={2}>
              { this.$t('page_operation_statistics_time_contrast') }
            </a-radio-button>
            <a-radio-button value={1}>
              { this.$t('page_operation_statistics_device_contrast') }
            </a-radio-button>
          </a-radio-group>}
          {this.loading ? this.renderLoading() : this.data.length > 0 ? this.data.map((item, index) => {
            return (
              <div class="operation-chartContent">
                <div style="width:100%; display:flex;align-items:center;justify-content: flex-start;">
                  <a-checkbox checked={item.checked} style="font-size: 22px;color: #37a2da; font-weight: bold" onChange={value => this.selectChart(value, item)}>
                    {this.searchType===1 ? item.workStationName : this.getShiftName(item.shiftName)}
                  </a-checkbox>
                </div>
                {this.chartBody(item, index)}
              </div>
            )
          }) : <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"><wm-empty text={this.$t('page_wm_empty')} /></div> }
        </div>
        {this.visible ? <a-modal maskClosable={false} visible={this.visible} width={700} centered title={ this.$t('page_operation_statistics_contrast') } onCancel={() => this.handleOk()} onOk={() => this.handleOk()}>
          <div style="width: 100%; overflow: auto">
            {this.chartRecheck()}
          </div>
        </a-modal> : null}
      </blank-view>
    )
  }
}
